export interface PassId {
	Id: number | null;
	Name: string;
	Description: string;
	PassTypeId: number | null;
	PassTypeName: string | null;
	PassShapeId: number | null;
	PassShapeName: string | null;
	StandId: number | null;
	StandName: string | null;
	/** Comma separated ids of the stands the pass can also be used on. */
	ExtraStandIds: string | null;
	ExtraStandNames: string | null;
	ScheduledTonnage: number;
	ScheduledBillets: number | null;
	Active: boolean;
}

export const PASS_ID_INITIAL_VALUES: PassId = {
	Id: null,
	Name: "",
	Description: "",
	PassTypeId: null,
	PassTypeName: null,
	PassShapeId: null,
	PassShapeName: null,
	StandId: null,
	StandName: null,
	ExtraStandIds: null,
	ExtraStandNames: null,
	ScheduledTonnage: 0,
	ScheduledBillets: 0,
	Active: true,
};

export interface PassType {
	Id: number;
	Name: string;
	Description: string;
	Active: boolean;
}

export interface PassShape {
	Id: number;
	Name: string;
	Description: string;
	Active: boolean;
}

export interface Stand {
	Id: number;
	Name: string;
	StandNumber: number | null;
	MillSizeId: number | null;
	Active: boolean;
}
